import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4def2f29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "¡Activa tu Cuentay disfruta de tu primer mes gratis!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Activa ahora tu suscripción y podrás acceder a todos los servicios de forma "),
  /*#__PURE__*/_createElementVNode("strong", null, "GRATUITA"),
  /*#__PURE__*/_createTextVNode(" durante el primer mes."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Somos transparentes. Podrás dar de baja tu suscripción en cualquier momento de forma sencilla."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Solo tienes que pulsar el botón de "),
  /*#__PURE__*/_createElementVNode("strong", null, "CANCELAR"),
  /*#__PURE__*/_createTextVNode(" en la sección de \"Mi Suscripción\". ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "¡Aprovecha la oferta anual!")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_7 = { class: "cards" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "inputProfile" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Mensual", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Suscripción Mensual", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "price-discount" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "paypal-button-container-month" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "inputProfile" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Anual", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Suscripción Anual", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "price" }
const _hoisted_27 = { class: "price-discount" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "paypal-button-container-year" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Disfruta de todo el contenido"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" al mejor precio.")
], -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { onMounted,ref, Ref } from 'vue';
import PaypPalService from '@/services/PayPalService'
import ProfileService from '@/services/ProfileService';
import { loadScript } from '@paypal/paypal-js';
import { useAuth } from '@/store/useAuth';
import router from '@/router';
import main from '@/data/main.js';



export default /*#__PURE__*/_defineComponent({
  __name: 'FreeProDevView',
  setup(__props) {

const service = new PaypPalService()
const userService = new ProfileService() 
const store = useAuth()
const data:Ref<any> = ref({})
    const user:Ref<any> = ref({})

/*onMounted(() => {
    setTimeout(() => {
        const paypalBTN = document.getElementById("paypal-button-container-P-19W68076RC250891AMXOHZ6Q");
        if (paypalBTN.childNodes.length == 0) {
            window.location.reload()
        }
    }, 1000)

})*/



onMounted(async () => {
  if(!store.token) {
    return
  }
 user.value = await userService.MyUser(store.token)
  const paypalSdk = await loadScript({  
    clientId: main.PAYPAL_ID_CLIENT,
    currency: 'EUR',
    vault: true
  });
  if(paypalSdk == null) { return }
  if(paypalSdk == undefined) { return }
  if(paypalSdk.Buttons == null) { return }

  paypalSdk.Buttons({
        createSubscription: function(data, actions) {
            if(user?.value?.paypal_id != 'null'){
          return actions.subscription.create({
           'plan_id': main.PLAN_ID_MONTH
           });}else{
            return actions.subscription.create({
           'plan_id': main.PLAN_ID_MONTH_NOT_FREE
           });
           }
         },
         onApprove: function(data, actions):any {
            window.location.assign(`prodev/bienvenida/${data.subscriptionID}`);
         }

    }).render('#paypal-button-container-month');

    paypalSdk.Buttons({

createSubscription: function(data, actions) {
    if(user?.value.paypal_id != 'null'){
        return actions.subscription.create({
   
   'plan_id': main.PLAN_ID_ANUAL
   });
   }else{
    return actions.subscription.create({
   
   'plan_id': main.PLAN_ID_ANUAL_NOT_FREE
   });
   }

 },
 onApprove: function(data, actions):any {
    window.location.assign(`prodev/bienvenida/${data.subscriptionID}`);
 }

}).render('#paypal-button-container-year');
data.value = await service.checkSub(store.token)
    if(data.value.status == 'ACTIVE'){
        router.push({name: 'count-prodev'})
    }
    
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("form", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createVNode(_component_v_icon, {
                name: "md-workspacepremium-sharp",
                class: "icon",
                hover: "true",
                animation: "wrench",
                style: {"scale":"4","margin-top":"10%","margin-bottom":"15%","fill":"#28a3bf"}
              }),
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(main).PRICE_MONTH) + "€", 1)
            ]),
            _hoisted_16,
            _hoisted_17
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("form", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _createVNode(_component_v_icon, {
                name: "md-workspacepremium-sharp",
                class: "icon",
                hover: "true",
                animation: "wrench",
                style: {"scale":"4","margin-top":"10%","margin-bottom":"15%","fill":"#28a3bf"}
              }),
              _hoisted_23,
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(main).PRICE_ANNUAL) + "€", 1)
              ])
            ]),
            _hoisted_28,
            _hoisted_29
          ])
        ]),
        _hoisted_30,
        _hoisted_31
      ])
    ]),
    _: 1
  }))
}
}

})